import background from "../assets/background.jpg"
import mobilebg from "../assets/mobilebg.jpg"
import title from "../assets/title.png"
import Navbar from "../components/Navbar"
import { motion, useAnimationControls } from "framer-motion"
import ContactButton from "./ContactButton"

export default function Header() {
    return(
        <>
            <img src={mobilebg} className="fixed sm:hidden h-screen w-screen -z-20 opacity-40"/>
            <img src={background} className="hidden sm:block sm:fixed h-screen w-screen -z-20 opacity-40"/>
            <div className="fixed h-screen w-screen -z-10 backdrop-blur-sm"/>
            <Navbar />
            <div className="h-screen w-screen flex flex-col items-center justify-center">
                <motion.img className='w-auto md:max-w-[40%] z-20'
                    initial={{ rotateZ: -2}}
                    animate={{ rotateZ: 2, transition: { ease: [0.1, 0.2, 0.8, 0.9], duration: 1, repeat: Infinity, repeatType:"reverse" }}}
                    whileHover={{ scale: 1.2, transition: { ease: [0.1, 0.2, 0.8, 0.9], duration: 0.5 }}}
                    src={title}
                />
                <motion.img className='w-auto md:max-w-[40%] opacity-10 absolute'
                    initial={{ rotate: -10, x: -20, y: -60}}
                    animate={{ rotateZ: 10, x: 20, y: 20, transition: { ease: [0.7, 0.2, 0.34, 0.86], duration: 3, repeat: Infinity, repeatType:"reverse"}}}
                    src={title}
                />
                <motion.img className='w-auto md:max-w-[40%] opacity-10 absolute'
                    initial={{ rotate: 10, x: 20, y: 20}}
                    animate={{ rotateZ: -10, x: -20, y: -60, transition: { ease: [0.7, 0.2, 0.34, 0.86], duration: 4, repeat: Infinity, repeatType:"reverse"}}}
                    src={title}
                />
                <ContactButton text="Contact Us"/>
            </div>
        </>
        
    );
}